import Language from '@/domain/language/Language';

export default class DataBreachReportLanguage extends Language {}
